<template>
    <div data-testid="job-position-dialog" v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-workposition" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Hantera
                </div>
                <v-form v-model="valid" ref="form">
                    <div class="modal-body pb-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col">
                                    <v-text-field data-testid="job-position-dialog-name-input" v-bind:disabled="disabled" :rules="[rules.required]" label="Namn" v-model="name" variant="outlined"></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-form>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn data-testid="job-position-dialog-close-button" color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn data-testid="job-position-dialog-save-button" v-bind:disabled="disabled" color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'
    import { ref } from 'vue'
    const form = ref(null);

    export default {
        emits: ['workpositionupdated'],
        name: 'update-workposition',
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                if (this.jobPositionId == -1) {
                    //await WorkOrganisationService.addJobPosition(this.name);
                    this.$emit("workpositionupdated", null);
                }
                else {
                    var updatedList = await WorkOrganisationService.updateJobPosition(this.jobPositionId, this.name, this.referencePosition);
                    this.$emit("workpositionupdated", updatedList);
                }
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            open(item) {
                this.name = item.Name !== undefined ? item.Name : item.name;
                this.jobPositionId = item.JobPositionId !== undefined ? item.JobPositionId : item.jobPositionId;
                this.referencePosition = item.ReferencePosition === true || item.referencePosition === true;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.jobPositionId = -1;
                this.referencePosition = false;
                this.name = "";
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                name: "",
                jobPositionId: -1,
                thisModal: {},
                referencePosition: false,
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {
             return { form }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
